var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useEffect, useLayoutEffect, useRef } from 'react';
import { useGame } from './useGame';
/**
 * Runs a callback every game step
 */
export function useFrame(callback) {
    var game = useGame();
    var ref = useRef(callback);
    useLayoutEffect(function () {
        ref.current = callback;
    }, [callback]);
    useEffect(function () {
        function run() {
            ref.current();
        }
        game.on('step', run);
        return function () {
            game.off('step', run);
        };
    }, [game, ref]);
}
/**
 * Iterates over a query result entity list every
 * game step
 */
export function useQueryFrame(input, callback) {
    useFrame(function () {
        var e_1, _a;
        try {
            for (var input_1 = __values(input), input_1_1 = input_1.next(); !input_1_1.done; input_1_1 = input_1.next()) {
                var ent = input_1_1.value;
                // FIXME:
                callback(ent);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (input_1_1 && !input_1_1.done && (_a = input_1.return)) _a.call(input_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    });
}
//# sourceMappingURL=useFrame.js.map